export default __webpack_public_path__ + "static/media/close-icon.32062f42.svg";